/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Studio_LeadInputs */

const en_for_whom_studio_lead = /** @type {(inputs: For_Whom_Studio_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainers, rooms and classes together.`)
};

const pl_for_whom_studio_lead = /** @type {(inputs: For_Whom_Studio_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy, sale i zajęcia razem.`)
};

/**
* | output |
* | --- |
* | "Trainers, rooms and classes together." |
*
* @param {For_Whom_Studio_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_studio_lead = /** @type {((inputs?: For_Whom_Studio_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Studio_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_studio_lead(inputs)
	return en_for_whom_studio_lead(inputs)
});